module.exports = __webpack_public_path__ + "static/media/NOP - Sunrise HWY 7.5dcc5c4a.pdf";